<section class="main-layout s-h-full">
  <section class="ecoupon-form">
    <div class="flex">
      @if(dataSignal()){
      <img src="{{ dataSignal().img }}" alt="" class="icon-m" />
      <p class="text-description">
        {{ dataSignal().message }}
      </p>
      <p class="text-description2">
        {{ dataSignal().message2 }}
      </p>
      }
    </div>

    <!-- <button mat-flat-button style="transform: skewX(-10deg)" class="w-full">ตกลง</button> -->
  </section>

  <!-- @if(){
    <span>รหัส OTP ไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง</span>
  } -->
</section>